import { OutletListItem, OutletState } from '@ancon/wildcat-types'
import isOutletAcceptingPreOrders from '@ancon/wildcat-utils/outlet/isOutletAcceptingPreOrders'

export default function isOutletAvailableForOrders(
  outlet: OutletListItem | null,
) {
  if (outlet) {
    const isOutletOpened = outlet.state === OutletState.Opened

    const isAcceptingPreOrders = isOutletAcceptingPreOrders(
      outlet.orderFormatSettings,
    )

    return isOutletOpened || isAcceptingPreOrders
  }

  return false
}
